import React, { useState } from "react";

const FilterChips = ({ title = "Chips", data = [], selectedItems, setSelectedItems }) => {
    const [selectedItemsShown, setSelectedItemsShown] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const allSelected = selectedItems.length === data.length;
    const selectAllId = `btn-check-select-all-${title.replace(/\s+/g, "-").toLowerCase()}`;

    const toggleChip = (slug) => {
        setSelectedItems((prev) =>
            prev.includes(slug)
                ? prev.filter((item) => item !== slug)
                : [...prev, slug]
        );
    };

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedItemsShown([]);
        } else {
            setSelectedItemsShown(data.map((item) => item.slug));
        }
    };

    const toggleShowAll = () => setShowAll((prev) => !prev);

    const visibleItems = showAll ? data : data.slice(0, 5);

    return (
        <div className="mb-2">
            <p className="fs-6 mb-1">{title}</p>

            <div className="d-inline-block">
                <input
                    type="checkbox"
                    className="btn-check"
                    id={selectAllId}
                    checked={allSelected}
                    onChange={toggleSelectAll}
                    autoComplete="off"
                />
                <label
                    className={`btn me-2 mb-2 ${allSelected ? "chip-selected" : "chip-default"}`}
                    htmlFor={selectAllId}
                >
                    All
                </label>
            </div>

            {visibleItems.map(({slug, value}) => (
                <div key={slug} className="d-inline-block">
                    <input
                        type="checkbox"
                        className="btn-check"
                        id={`btn-check-${slug}`}
                        checked={selectedItems.includes(slug)}
                        onChange={() => toggleChip(slug)}
                        autoComplete="off"
                    />
                    <label
                        className={`btn me-2 mb-2 ${
                            selectedItems.includes(slug)
                                ? "chip-selected"
                                : "chip-default"
                        }`}
                        htmlFor={`btn-check-${slug}`}
                    >
                        {value}
                    </label>
                </div>
            ))}

            {data.length > 5 && (
                <div className="text-end mt-2">
                    <button
                        className="btn bg-white border-0 p-0 fw-light fs-6 active"
                        onClick={toggleShowAll}
                    >
                        <i
                            className={`bi ${
                                showAll ? "bi-caret-up-fill" : "bi-caret-down-fill"
                            }`}
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default FilterChips;
